<template>
  <div>
    <v-data-table
      :headers="headersCategories"
      :items="categories"
      class="elevation-1"
    >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Categoría</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                 <v-btn outlined color="blue"  @click="modalCategoryCreate()" class="ml-4">Crear Categoría</v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogCategory" max-width="550px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Editar Categoría</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                           <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedCategory._id" label="Id" disabled></v-text-field>
                          </v-col>
                           <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedCategory.date" label="Fecha" disabled></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedCategory.name" type="text" label="Nombre"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeEditCategory">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="saveEditCategory">Guardar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.date="{ item }">
              {{item.date | momentDateTable}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editCategory(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="modalDelete(item)"
              >
                mdi-delete
              </v-icon>
            </template>
    </v-data-table>
     <!-- modal create Category -->
      <v-dialog v-model="dialogCategoryCreate" persistent max-width="500">
        <v-card>
          <v-card-title class="card-title d-flex justify-space-between">
            <span class="headline">Nueva Categoría</span>
          </v-card-title>
              <v-card-text>
                <v-form  v-model="validCategory" ref="form" @submit.prevent="saveCategory" enctype="multipart/form-data">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="category.name" type="text" :rules="nameRules" label="Nombre" required></v-text-field>
                    </v-col>
                  <v-card-actions style="width:100%;">
                    <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click.stop="dialogCategoryCreate = false" >Cancelar</v-btn>
                      <v-btn color="blue darken-1" :disabled="!validCategory" type="submit" text >Guardar</v-btn>
                  </v-card-actions>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
      </v-dialog>
      <!-- START - DIALOG DELETE -->
      <v-dialog v-model="dialogDelete" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Desea eliminar a {{this.editedCategory.name}} ?</v-card-title>
          <v-card-text>No podrá recuperarlo.</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="green darken-1" text @click="dialogDelete = false">No</v-btn>
            <v-btn color="green darken-1" text @click="deleteCategory()">Si</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END - DIALOG DELETE -->
  </div>
</template>

<script>
const moment = require('moment');
  export default {
    name:'category',
    created(){
      this.obtenerDatosCategory()
    },
    data(){
      return{
        dialogCategoryCreate:false,
        dialogCategory: false,
        validCategory:true,
        categories:[],
        dialogDelete:false,
        category:{
          name:'',
        },
         headersCategories: [
          { text: 'Nombre', value: 'name',align: 'center' },
          { text: 'fecha', value: 'date' ,align: 'center'},
          { text: 'Acción', value: 'action',align: 'center', sortable: false },
        ],
        editedCategory: {
          name: '',
          date:''
        },
        defaultCategory: {
          name: '',
          date:''
        },
        nameRules: [
          v => !!v || 'Nombre es requerido',
        ],
      }
    },
    methods:{
       async obtenerDatosCategory(){
        await this.axios.get(`${this.$store.state.baseURL}/api/category`)
          .then(res => {
            const resultadoCategory = res.data 
            this.categories = resultadoCategory
          })
      },
      modalCategoryCreate(){
        this.dialogCategoryCreate = true;
      },
      async saveCategory(){
        const formData = new FormData()
        formData.append('name',this.category.name.toLowerCase())
        await this.axios.post(`${this.$store.state.baseURL}/api/category`,formData,{
          headers: { token: localStorage.getItem('token')}
          })
        .then(res => {
          this.obtenerDatosCategory()
          this.category.name = ''
          // console.log('category creada');
          
        })
        .catch(err =>{
          console.log(err);
        })
        this.dialogCategoryCreate = false
      },
      editCategory (item) {
        this.editedIndexCa= this.categories.indexOf(item)
        this.editedCategory = Object.assign({}, item)
        this.dialogCategory = true
        moment.locale('es');
        const momentDate = moment(this.editedCategory.date).format('MMMM Do YYYY, h:mm:ss a')
        this.editedCategory.date = momentDate    
      },
      modalDelete(item){
        this.editedCategory = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteCategory () {
        this.axios.delete(`${this.$store.state.baseURL}/api/category/`+this.editedCategory._id,{
          headers: { token: localStorage.getItem('token')}
          })
          .then(res => {
            this.obtenerDatosCategory()
            // console.log('categoria Eliminada');
            this.dialogDelete = false
          })
      },
      closeEditCategory () {
        this.dialogCategory = false
      },
      async saveEditCategory () {
        await this.axios.put(`${this.$store.state.baseURL}/api/category/`+ this.editedCategory._id,{
          name:this.editedCategory.name.toLowerCase()
        },{
           headers: { token: localStorage.getItem('token')}
        })
        .then(res => {
          this.obtenerDatosCategory()
          // console.log('categoria actualzado');
        })
        .catch(err => {
          console.log(err)
        })
        this.closeEditCategory()
      }
    },
    filters:{
      momentDateTable(value) {
        moment.locale('es');
        return moment(value).format('ll')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>